import { BodyMedium, LinkButton, theme, DeprecatedChevronUpIcon, DeprecatedChevronDownIcon } from '@arnold/common';
import styled from '@emotion/styled';
import i18n from 'i18next';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

const Filter = styled.div`
  display: flex;
  gap: ${theme.spacing.d};
`;

const StyledLinkButton = styled(LinkButton)`
  margin: 0;
  display: flex;
  align-items: center;
  gap: ${theme.spacing.c};
  margin-left: ${theme.spacing.d};
`;

const Pill = styled.span`
  width: ${theme.spacing.f};
  height: ${theme.spacing.f};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.typography.body.small.regular.fontSize};
  background-color: ${theme.colors.actionPrimary.default};
  color: ${theme.colors.textInverted.primary};
  line-height: ${theme.spacing.f};
  letter-spacing: normal;
`;

const getDateFilterTitle = (t: any, from?: string | null, to?: string | null) => {
  if (from && to) {
    return `${new Date(from).toLocaleDateString(i18n.language)} - ${new Date(to).toLocaleDateString(i18n.language)}`;
  }

  if (from) {
    return `${t('from')} ${new Date(from).toLocaleDateString(i18n.language)}`;
  }

  if (to) {
    return `${t('to')} ${new Date(to).toLocaleDateString(i18n.language)}`;
  }

  return null;
};

export type NavbarFilterProps = {
  title: string;
  addedOnFrom?: string | null;
  addedOnTo?: string | null;
  setShowFilters: React.Dispatch<React.SetStateAction<boolean>>;
  pillNumber: number;
  showFilters: boolean;
  compact?: boolean;
};

export const NavbarFilter = forwardRef<HTMLDivElement, NavbarFilterProps>(
  ({ title, addedOnFrom, addedOnTo, setShowFilters, pillNumber, showFilters, compact }, ref) => {
    const { t } = useTranslation(['Report']);

    return (
      <Filter>
        {!compact && (
          <>
            <BodyMedium color={theme.colors.text.disabled}>{title}</BodyMedium>
            {(addedOnFrom || addedOnTo) && (
              <>
                {title && <BodyMedium color={theme.colors.text.disabled}>{'|'}</BodyMedium>}
                <BodyMedium bold>{getDateFilterTitle(t, addedOnFrom, addedOnTo)}</BodyMedium>
              </>
            )}
          </>
        )}
        <div ref={ref}>
          <StyledLinkButton
            key={showFilters.toString()}
            onClick={() => {
              setShowFilters((prevValue) => !prevValue);
            }}
          >
            <Pill>{pillNumber}</Pill>
            {t('filters')}
            {showFilters ? <DeprecatedChevronUpIcon /> : <DeprecatedChevronDownIcon />}
          </StyledLinkButton>
        </div>
      </Filter>
    );
  },
);
